import {
    LazyModule,
    createLazyComponent,
    LazyAction,
    registerLazyOrchestrator,
    LazyImport,
} from 'owa-bundling';
import {
    openBookingCompose,
    editBookingMeeting,
} from 'bookwithme-routes/lib/actions/bookWithMeRoutesActions';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "BookwithmeOrganizer" */ './lazyIndex'),
    { name: 'BookwithmeOrganizer' }
);

// Lazy component
export const BookingDashboardModule = createLazyComponent(
    lazyModule,
    m => m.BookingDashboardModule
);

export const BookingEventListItem = createLazyComponent(lazyModule, m => m.BookingEventListItem);

export const BookingComposeForm = createLazyComponent(lazyModule, m => m.BookingComposeForm);
export const ThemeSelector = createLazyComponent(lazyModule, m => m.ThemeSelector);
export const ComposeMeetingAvailability = createLazyComponent(
    lazyModule,
    m => m.ComposeMeetingAvailability
);
export const DurationDropdown = createLazyComponent(lazyModule, m => m.DurationDropdown);
export const ShareModal = createLazyComponent(lazyModule, m => m.ShareModal);
export const BookingPageShareButton = createLazyComponent(
    lazyModule,
    m => m.BookingPageShareButton
);

// Lazy Actions
export const lazySetMailboxHash = new LazyAction(lazyModule, m => m.setMailboxHash);
export const lazySetOrganizerEntryPoint = new LazyAction(lazyModule, m => m.setEntryPoint);
export const lazySetOrganizerMeetingDetails = new LazyAction(
    lazyModule,
    m => m.setMeetingDetailsFromUrl
);
export const lazyRetrievePbEnabledStatus = new LazyAction(
    lazyModule,
    m => m.retrievePbEnabledStatus
);
export const lazySetMeetingTypeAvailability = new LazyAction(
    lazyModule,
    m => m.setMeetingTypeAvailability
);
export const lazySetShowServiceOutageBanner = new LazyAction(
    lazyModule,
    m => m.setShowServiceOutageBanner
);
export const lazyResetmeetingTypeEditState = new LazyAction(
    lazyModule,
    m => m.resetmeetingTypeEditState
);
export const lazyShareModalDismiss = new LazyAction(lazyModule, m => m.shareModalDismiss);
export const lazySetMeetingTypeId = new LazyAction(lazyModule, m => m.setMeetingTypeId);
export const lazySetEditStatePrivacyType = new LazyAction(
    lazyModule,
    m => m.setEditStatePrivacyType
);

export const lazyGetPbEnabledStatus = new LazyImport(lazyModule, m => m.getPbEnabledStatus);

registerLazyOrchestrator(openBookingCompose, lazyModule, m => m.openOrganizerComposeOrchestrator);
registerLazyOrchestrator(editBookingMeeting, lazyModule, m => m.editMeetingTypeOrchestrator);
